import Vue from 'vue'
import JS from '../../bankrate-utilities'

/**
 * Format fixed decimal points on value
 */
Vue.filter('decimalFormat', (value, places) => value.toFixed(places))

/**
 * Remove spaces from value
 */
Vue.filter('spacesFormat', text => text.toString().replace(/ /g, ''))

/**
 * Format number with comma
 */
// Vue.filter('commaFormat', number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
Vue.filter('commaFormat', number => {
  let elements = number.toString().split('.')
  elements[0] = elements[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return elements.join('.')
})

/**
 * Format as phone number
 */
Vue.filter('phoneFormat', phone =>
  phone
    .toString()
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})?(\d{3})(\d{4})$/, '$1-$2-$3')
)

/**
 * Remove non numeric characters from value
 */
Vue.filter('cleanNumericValue', value => value.replace(/\D/g, ''))

/**
 * Replace abbreviation for year
 */
Vue.filter('termFormatExpanded', term => term.replace('yr', 'year'))

/**
 * Round passed value
 */
Vue.filter('round', value => Math.round(value))

/**
 * Format date string
 */
Vue.filter('dateFormat', date => {
  let dNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  let mNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ]
  let d = new Date(date)
  return `${dNames[d.getDay()]} ${mNames[d.getMonth()]} ${d.getDate()}`
})

/**
 * Format term string
 */
Vue.filter('termFormat', number => {
  let text = number.toString().split(' ')
  let multiYear = text[0] === '1' ? '' : 's'
  text[1] = text[1].replace('month', 'mo')
  return `${text[0]}<span class="numeral__accent">${text[1]}${multiYear}</span>`
})

/**
 * Replace abbreviations in auto titles with complete/correct words
 */
Vue.filter('autoProductFilter', value => {
  if (value) {
    let filtered = value.replace('Mo', 'Month')
    filtered = filtered.replace('Auto', 'Auto Loan')
    filtered = filtered.replace('Car', 'Auto Loan')
    filtered = filtered.replace('Refi', 'Refinance')
    return filtered
  }
  return ''
})

// these methods are in ~\bankrate-utilities\index.js
export default {
  methods: {
    closest: JS.closest,
    arrayObjectIndexOf: JS.arrayObjectIndexOf,
    arrayObjectAllIndexes: JS.arrayObjectAllIndexes,
    isObjectEmpty: JS.isObjectEmpty,
    isNumeric: JS.isNumeric,
    getBrOption: JS.getBrOption,
    getParameterByName: JS.getParameterByName,
    isValidForm: JS.isValidForm,
    isValidZip: JS.isValidZip,
    scrollToPosition: JS.scrollToPosition,
    isMobile: JS.isMobile,
    isDesktop: JS.isDesktop,
    slugify: JS.slugify,
    getUrlParameter: JS.getUrlParameter,
    processPixel: JS.processPixel
  }
}
